import { Routes } from '@angular/router';
import { modulosLayoutRoutes } from '@pages/modules/modules-layout.routes';

export const inicioRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('@pages/inicio/home/home.component'),
  },
  {
    path: 'settings',
    loadComponent: () => import('@pages/inicio/configuraciones/configuraciones.component'),
  },
  {
    path: 'ayuda',
    loadComponent: () => import('@pages/inicio/ayuda/ayuda.component'),
  },
  ...modulosLayoutRoutes,
];
